import { useState } from 'react';
import _get from 'lodash/get';

import { localStore } from 'utils';
import useMutation from './useMutation';
import useAppContext from './useAppContext';
import { STORAGE_KEYS } from 'utils/DICTIONARY';

export default function useStoreSwitch() {
  const [storeData, setStoreData] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  const { isSSREnv } = useAppContext();

  const { mutate: onVerify, isProcessing: isValidating } = useMutation(
    'retailerVerify',
    'POST',
    {
      errorMessage: 'Unable to verify the store. Please try again.',
      payload: () => {},
      onError: () => setIsError(true)
    }
  );

  const onStoreSwitch = (data = {}) => {
    const id = _get(data, 'id');
    const storeName = _get(data, 'storeName');
    const storeUniqueName = _get(data, 'storeUniqueName');

    if (!id || !storeUniqueName) return;

    const key = isSSREnv ? 'seller_store_guid' : 'rr_store_id';
    setIsSwitching(true);
    setStoreData({ id, storeName, storeUniqueName });
    onVerify({ [key]: id }, err => {
      if (err) return;
      setTimeout(() => {
        localStore.put(STORAGE_KEYS.LOGGED_IN_STORE_NAME, storeUniqueName);
        const key = isSSREnv
          ? STORAGE_KEYS.LOGGED_IN_STORE_GUID
          : STORAGE_KEYS.LOGGED_IN_STORE_ID;
        localStore.put(key, id);
        window.location = '/';
      }, 500);
    });
  };

  const onCloseModal = () => {
    setStoreData(null);
    setIsSwitching(false);
  };

  return {
    storeData,
    isError,
    isSwitching,
    isValidating,
    isProcessing: isSwitching || isValidating,
    onStoreSwitch,
    onCloseModal
  };
}
